import { Button } from "antd";
import { useGetUserQuery } from "api/TenantSlug/User/hooks.ts";
import { ManageAdvertiserForm } from "components/Forms/ManageAdvertiserForm/ManageAdvertiserForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

interface AdvertiserDetailDrawerProps {
    advertiserId: string;
}

export const AdvertiserDetailDrawer: FC<AdvertiserDetailDrawerProps> = ({ advertiserId }) => {
    const { t: tCommon } = usePaldockTranslation("common");
    const id = DrawerId.AdvertiserDetail;

    const { data } = useGetUserQuery(
        advertiserId,
        { filter: { include: "tenantSettings" } },
        { enabled: !!advertiserId }
    );
    const { user } = data || {};

    const extraButtons = (
        <Button size="large" type="primary" htmlType="submit" form={FormId.AddUserForm}>
            {tCommon("save")}
        </Button>
    );

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={user?.nickname ?? "---"} />}
            extraButtons={extraButtons}
            searchParamsToClean={getDrawerSearchParams(id, "advertiserId")}
        >
            <DrawerContent>
                <ManageAdvertiserForm mode="detail" user={user} />
            </DrawerContent>
        </Drawer>
    );
};
